import React from 'react';
import './ContentSplit.styles.scss';
import { ContentSplitProps } from './ContentSplit.logic';

const ContentSplit: React.FC<ContentSplitProps> = ({
  className,
  image,
  position = 'right',
  children,
}) => {
  return (
    <div className={`content-split content-split-${position} ${className}`}>
      <div className="content-split-wrapper">
        <div
          className="content-split-image content-split-block action-on-view action-fade-in action-delay-250"
          style={{ backgroundImage: `url(${image})` }}
        />
        <div className="content-split-content content-split-block">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContentSplit;
